export enum UserRole {
  PublisherAdmin = 'PublisherAdmin',
  AccountManager = 'AccountManager',
  ReportUser = 'ReportUser',
  ListManager = 'ListManager',
  AdView = 'AdViewer',
  SuperAdmin = 'SuperAdmin'
}
